// Lightweight enhancements for SEO landing pages.
// Intentionally separate from main.js so pages stay minimal.

function markActiveNav() {
  const path = window.location.pathname;
  const links = document.querySelectorAll('.app-nav .nav-link');
  links.forEach(a => a.classList.remove('nav-link--active'));

  if (path.startsWith('/medicines/')) {
    document.querySelector('.app-nav a[href="/medicines/"]')?.classList.add('nav-link--active');
  } else {
    document.querySelector('.app-nav a[href="/"]')?.classList.add('nav-link--active');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  markActiveNav();
  const yearEl = document.getElementById('year');
  if (yearEl) yearEl.textContent = new Date().getFullYear();
});
